/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnectionScheduleSitesConfig } from './ICRTouchConnectionScheduleSitesConfig';
import {
    ICRTouchConnectionScheduleSitesConfigFromJSON,
    ICRTouchConnectionScheduleSitesConfigFromJSONTyped,
    ICRTouchConnectionScheduleSitesConfigToJSON,
    ICRTouchConnectionScheduleSitesConfigToJSONTyped,
} from './ICRTouchConnectionScheduleSitesConfig';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListIcrTouchConnectionScheduleSitesConfigResponse
 */
export interface ListIcrTouchConnectionScheduleSitesConfigResponse {
    /**
     * 
     * @type {Array<ICRTouchConnectionScheduleSitesConfig>}
     * @memberof ListIcrTouchConnectionScheduleSitesConfigResponse
     */
    data: Array<ICRTouchConnectionScheduleSitesConfig>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListIcrTouchConnectionScheduleSitesConfigResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListIcrTouchConnectionScheduleSitesConfigResponse interface.
 */
export function instanceOfListIcrTouchConnectionScheduleSitesConfigResponse(value: object): value is ListIcrTouchConnectionScheduleSitesConfigResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListIcrTouchConnectionScheduleSitesConfigResponseFromJSON(json: any): ListIcrTouchConnectionScheduleSitesConfigResponse {
    return ListIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json, false);
}

export function ListIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIcrTouchConnectionScheduleSitesConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ICRTouchConnectionScheduleSitesConfigFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListIcrTouchConnectionScheduleSitesConfigResponseToJSON(json: any): ListIcrTouchConnectionScheduleSitesConfigResponse {
      return ListIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(json, false);
  }

  export function ListIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(value?: ListIcrTouchConnectionScheduleSitesConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ICRTouchConnectionScheduleSitesConfigToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

